// removed by extract-text-webpack-plugin
module.exports = {"postPage":"_3kIJh","emptyState":"_2MtAe","postContainer":"J6lDs","postContentWrapper":"_2U6Fr","edited":"_38NBw","editedDate":"_2jV7L","editIcon":"_1mWA-","postStatsContainer":"_3F9Jj","postContent":"_3XCeb"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/post-page/post-page.scss
// module id = 1741
// module chunks = 0